import React from 'react';
import FilterTagsMobile from 'src/components/CollegeSearch/FilterTags/FilterTagsMobile';
import AdmissionFilters from 'src/components/CollegeSearch/Filters/AdmissionFilters';
import AttributeFilters from 'src/components/CollegeSearch/Filters/AttributeFilters';
import CostFilters from 'src/components/CollegeSearch/Filters/CostFilters';
import DiversityFilters from 'src/components/CollegeSearch/Filters/DiversityFilters';
import GraduationFilters from 'src/components/CollegeSearch/Filters/GraduationFilters';
import LocationFilters from 'src/components/CollegeSearch/Filters/LocationFilters';
import MajorsFilters from 'src/components/CollegeSearch/Filters/MajorsFilters';
import NcaaFilters from 'src/components/CollegeSearch/Filters/NcaaFilters';
import SizeFilters from 'src/components/CollegeSearch/Filters/SizeFilters';
import TagsFilters from 'src/components/CollegeSearch/Filters/TagsFilters';
import TypeFilters from 'src/components/CollegeSearch/Filters/TypeFilters';
import CollegeNameFilter from 'src/components/CollegeSearch/Filters/college-name-filter';
import useUserType from 'src/hooks/use-user-type/use-user-type';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

interface Props {
  getColleges: () => void;
}

const Filters = ({getColleges}: Props) => {
  const {isTransfer} = useUserType();

  const mq = useMediaQuery();

  return (
    <div className="college-search-filters-sidebar" role="group" aria-label="Filter Colleges">
      {mq.MS_AND_DOWN && <FilterTagsMobile />}
      <CollegeNameFilter getColleges={getColleges} />
      <LocationFilters />
      <AttributeFilters getColleges={getColleges} />
      <MajorsFilters getColleges={getColleges} />
      <TypeFilters getColleges={getColleges} />
      <CostFilters getColleges={getColleges} />
      {!isTransfer && <AdmissionFilters getColleges={getColleges} />}
      <SizeFilters getColleges={getColleges} />
      <NcaaFilters getColleges={getColleges} />
      <DiversityFilters getColleges={getColleges} />
      <GraduationFilters getColleges={getColleges} />
      <TagsFilters getColleges={getColleges} />
    </div>
  );
};

export default Filters;
